import { ref, getCurrentInstance } from 'vue'

export default function useFavoriteModule() {
	const app = getCurrentInstance()
	const { $axios } = app.appContext.config.globalProperties

	const favoriteModule = async (module, data, prop, id) => {
		const url = ref('')

		const getModuleUrl = () => {
			switch (module) {
				case 'courses':
					return `/etraining_courses/group_training/${id}/set_group_training_user_favorite/`
				case 'trails':
					return `/etraining_trails/trails/${id}/set_trail_user_favorite/`
				case 'podcasts':
					return `/etraining_podcast/podcasts/${id}/set_user_favorite/`
				default:
					return ''
			}
		}

		url.value = getModuleUrl()

		const obj = data.find((obj) => obj.id === id)

		if (obj) obj[prop] = !obj[prop]

		const fd = new FormData()

		try {
			const response = await $axios.post(url.value, fd)
			obj[prop] = response.data[prop]
		} catch (e) {
			console.log(e)
		}
	}

	return favoriteModule
}
